<template>
  <div class="description-area">
    <i v-if="italic" v-html="italic"/>
    <h3 v-if="title" v-html="title"/>
    <p v-if="description" v-html="description"/>  
  </div>
</template>

<script>
export default {
  name: 'DescriptionArea',
  props: {
    title: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    },
    italic: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
  @import './../../assets/scss/breakpoint.scss';
  @import './../../assets/scss/typo.scss';
  
  .description-area{
    text-align: center;
    margin-top: 3rem;
    padding-top: 2rem;
    padding-bottom: 1rem;
    @include media(">=small"){
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
    @include media(">=medium"){
      padding-top: 2rem;
      padding-bottom: 2.5rem;
    }
    @include media(">=large"){
      padding-top: 2.5rem;
      padding-bottom: 3rem;
      margin-top: 4rem;
    }

    h3{
      text-align: center;
      margin: 1.5rem 0 2rem;
      @include media(">=large"){
        margin: 1.5rem 0 3rem;
      }
    }
    p{
      text-align: center;
      margin: 0 0 1.5rem;
    }
    i{
      text-align: center;
      margin: 1.5rem 0 .5rem;
    }
  }

</style>
  